import { FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SelectOptions } from "~/types/Select";
import { useGetLocationData } from "~/hooks/locationData";
import { OpenModalActions } from "~/types/OpenModalActions";

type GetFieldsParams = {
  errors: any;
  infoSystems: SelectOptions[];
  intersectionObserver: any;
  searchText: any;
};
export const getFields = ({
  errors,
  infoSystems,
  intersectionObserver,
  searchText,
}: GetFieldsParams) => {
  const { t } = useTranslation();

  const { openModal } = useGetLocationData();

  const isView = openModal === OpenModalActions.View;

  return [
    {
      isInput: true,
      name: "name",
      label: t("personal_data.name"),
      error: errors["name"]?.message || "",
      disabled: Boolean(isView),
    },
    {
      isSelect: true,
      name: "infoSystem",
      label: t("personal_data.informationSystem"),
      scrollBottom: intersectionObserver,
      searchText: searchText,
      options: infoSystems,
      error: (errors as FieldErrors)["infoSystem"]?.value?.message || "",
      disabled: Boolean(isView),
    },
    {
      isFilePicker: true,
      name: "file",
      label: t("personal_data.file"),
      error: errors["file"]?.message || "",
      errors: errors,
    },
  ];
};
